module.exports = __webpack_public_path__ + "static/media/matching.e3abc497.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/matching.png
// module id = 1791
// module chunks = 0